import { ConfirmDialog } from '@/components/Account/ConfirmDialog';
import { MasterTranslation } from '@/constants';
import { useGlobalState } from '@/hooks';
import type { FC } from 'react';

interface LogoutConfirmDialogProps {
  showDialog: boolean;
  setShowDialog: (show: boolean) => void;
  onLogout: () => void;
}

export const LogoutConfirmDialog: FC<LogoutConfirmDialogProps> = ({ showDialog, setShowDialog, onLogout }) => {
  const { t } = useGlobalState();

  return (
    <ConfirmDialog
      showDialog={showDialog}
      setShowDialog={setShowDialog}
      onConfirm={onLogout}
      mainText={t(MasterTranslation.AccLogoutPopupTitle)}
      subText={t(MasterTranslation.AccLogoutPopupSubtitle)}
      cancelText={t(MasterTranslation.AccCancelCta)}
      confirmText={t(MasterTranslation.AccLogoutCtaUpperCase)}
    />
  );
};
